import {
  BlockColorsItem,
  DragHandleMenu,
  RemoveBlockItem,
  TableColumnHeaderItem,
  TableRowHeaderItem,
  useDictionary,
} from '@blocknote/react';

import { TurnIntoBlockItem } from './TurnIntoBlockItem.web';

export function CouplespaceDragHandleMenu() {
  const dict = useDictionary();

  return (
    <DragHandleMenu>
      <TurnIntoBlockItem>Turn into</TurnIntoBlockItem>
      <BlockColorsItem>{dict.drag_handle.colors_menuitem}</BlockColorsItem>
      <RemoveBlockItem>{dict.drag_handle.delete_menuitem}</RemoveBlockItem>
      <TableRowHeaderItem>{dict.drag_handle.header_row_menuitem}</TableRowHeaderItem>
      <TableColumnHeaderItem>{dict.drag_handle.header_column_menuitem}</TableColumnHeaderItem>
    </DragHandleMenu>
  );
}
